import { render } from "./SessionQuestionsProgramListing.vue?vue&type=template&id=00c5e8dc&scoped=true&ts=true"
import script from "./SessionQuestionsProgramListing.vue?vue&type=script&lang=ts"
export * from "./SessionQuestionsProgramListing.vue?vue&type=script&lang=ts"

import "./SessionQuestionsProgramListing.vue?vue&type=style&index=0&id=00c5e8dc&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c5e8dc"]])

export default __exports__